const AppHome = () => import('@/pages/AppHome')
const MainSettings = () => import('@/pages/MainSettings')

const FindPeople = () => import('@/pages/FindPeople')

const EmployeeSettings = () => import("@/pages/employees/EmployeeSettings")

const Projects = () => import('@/pages/Projects')
const Services = () => import('@/pages/Services')

const Project = () => import('@/pages/Project')

const ServiceDetails = () => import('@/pages/project/services/ServiceDetails')
const ServiceInvoice = () => import("@/pages/project/services/ServiceInvoice")
const ServicePurchaseOrders = () => import("@/pages/project/services/ServicePurchaseOrders")

const JobMessages = () => import("@/pages/project/JobMessages")

const PunchClock = () => import("@/pages/PunchClock")

const TimeLogs = () => import("@/pages/time_logs/TimeLogs")
const TimeLogsPeriod = () => import("@/pages/time_logs/TimeLogsPeriod")

const Expenses = () => import("@/pages/Expenses")

const FormTemplates = () => import('@/pages/forms/FormTemplates')
 
const LibraryList = () => import("@/pages/library/LibraryList")

export default [
	{
		path: '/canvas',
		name: 'Canvas',
		component: () => import("@/pages/CanvasTouchTest"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import("@/pages/Login"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/login/:partnerAccess',
		name: 'PartnerAccessLogin',
		component: () => import("@/pages/Login"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import("@/pages/Register"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/accept-invite/:token',
		name: 'RegisterInvite',
		component: () => import("@/pages/register/RegisterInvite"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/',
		name: 'Home',
		component: AppHome
	},
	{
		path: '/dashboard',
		name: 'HomeDashboard',
		component: AppHome
	},
	{
		path: '/reset-password/:token',
		name: 'PasswordReset',
		component: () => import('@/pages/PasswordReset')
	},
	{
		path: '/find',
		name: 'FindPeople',
		component: FindPeople
	},
	{
		path: '/settings',
		name: 'MainSettings',
		component: MainSettings
	},
	{
		path: '/settings/:tab',
		name: 'MainSettingsTab',
		component: MainSettings
	},
	{
		path: '/settings/:tab/error/:error_message',
		name: 'MainSettingsTabWithErrorMessage',
		component: MainSettings
	},
	{
		path: '/employees/list',
		name: 'EmployeeList',
		component: () => import('@/pages/employees/EmployeeList')
	},
	{
		path: '/employees/apps',
		name: 'EmployeesApps',
		component: () => import('@/pages/employees/EmployeesApps')
	},
	{
		path: '/employees/settings',
		name: 'EmployeeSettings',
		component: EmployeeSettings
	},
	{
		path: '/employees/settings/:tab',
		name: 'EmployeeSettingsWithTab',
		component: EmployeeSettings
	},
	{
		path: '/employees/settings/:tab/:tag',
		name: 'EmployeeSettingsWithTag',
		component: EmployeeSettings
	},
	{
		path: '/employee/new',
		name: 'NewEmployee',
		component: () => import('@/pages/employees/employee_tabs/NewEmployee')
	},
	{
		path: '/employee/:id/:tab',
		name: 'Employee',
		component: () => import('@/pages/Employee')
	},
	{
		path: '/projects/list',
		name: 'ProjectsList',
		component: Projects
	},
	{
		path: '/projects/reports/:report_type',
		name: 'ProjectsReportsWithType',
		component: () => import('@/pages/reports/ReportsProjects')
	},
	{
		path: '/projects/reports',
		name: 'ProjectsReports',
		component: () => import('@/pages/reports/ReportsProjects')
	},
	{
		path: '/projects/bid-templates',
		name: 'ProjectBidTemplates',
		component: () => import("@/pages/ProjectBidTemplates")
	},
	{
		path: '/projects/:tab',
		name: 'ProjectsTab',
		component: Projects
	},
	{
		path: '/project/apps',
		name: 'ProjectsApps',
		component: () => import('@/pages/ProjectsApps')
	},
	{
		path: '/projects',
		name: 'Projects',
		component: Projects
	},
	{
		path: '/service-contracts/:tab',
		name: 'ServiceContractsWithTab',
		component: () => import("@/pages/project/ServiceContracts")
	},
	{
		path: '/service-contracts',
		name: 'ServiceContracts',
		component: () => import("@/pages/project/ServiceContracts")
	},
	{
		path: '/service-tasks',
		name: 'ServiceTasks',
		props: {
			isGlobalTasks: true
		},
		component: () => import("@/pages/project/service_contract/ServiceContractTasks")
	},
	{
		path: '/quote-templates',
		name: 'QuoteTemplates',
		component: () => import("@/pages/project/QuoteTemplates")
	},
	{
		path: '/service-contract/:slug/details',
		name: 'ServiceContractDetails',
		component: () => import("@/pages/project/service_contract/ServiceContractDetails")
	},
	{
		path: '/service-contract/:slug/tasks',
		name: 'ServiceContractTasks',
		component: () => import("@/pages/project/service_contract/ServiceContractTasks")
	},
	{
		path: '/service-contract/:slug/materials',
		name: 'ServiceContractMaterials',
		component: () => import("@/pages/project/service_contract/ServiceContractMaterials")
	},
	{
		path: '/service-contract/:slug/files',
		name: 'ServiceContractFiles',
		component: () => import("@/pages/project/JobFiles"),
		props: {
			storeLocation: "serviceContract",
			parentResource: "ServiceContract",
			parentRecordSlugRouteParamKey: "slug"
		}
	},
	{
		path: '/service-contract/:slug/products',
		name: 'ServiceContractProducts',
		component: () => import("@/pages/project/service_contract/ServiceContractProducts")
	},
	{
		path: '/service-contract/:slug/personnel',
		name: 'ServiceContractPersonnelTab',
		component: () => import("@/pages/project/PersonnelTab"),
		props: {
			module: "Contracts",
			storeLocation: "serviceContract",
			jobType: "Service Contract",
			noWidget: true
		}
	},
	{
		path: '/services/reports',
		name: 'ReportsServicesDashboard',
		//component: () => import("@/pages/reports/ReportsServices")
		component: () => import("@/pages/reports/ReportsServicesDashboard")
	},
	{
		path: '/services/:filter',
		name: 'ServicesFiltered',
		component: Services
	},
	{
		path: '/services',
		name: 'Services',
		component: Services
	},
	{
		path: '/service/apps',
		name: 'ServicesApps',
		component: () => import("@/pages/project/services/ServicesApps")
	},
	{
		path: '/service/:id/dashboard',
		name: 'ServiceDashboard',
		component: () => import('@/pages/project/services/ServiceDashboard')
	},
	{
		path: '/service/:id/personnel',
		name: 'PersonnelTab',
		component: () => import('@/pages/project/PersonnelTab'),
		props: {
			module: "Services",
			storeLocation: "service",
			jobType: "Service"
		}
	},
	{
		path: '/service/:id/details',
		name: 'ServiceDetails',
		component: ServiceDetails
	},
	{
		path: '/service/:id/details/:tag',
		name: 'ServiceDetailsWithTag',
		component: ServiceDetails
	},
	{
		path: '/service/:id/quote',
		name: 'ServiceQuote',
		component: ServiceInvoice
	},
	{
		path: '/service/:id/worksheet',
		name: 'ServiceWorkSheet',
		component: () => import('@/pages/project/services/ServiceWorkSheet')
	},
	{
		path: '/service/:id/messages',
		name: 'ServiceMessages',
		component: () => import("@/pages/project/services/ServiceMessages")
	},
	{
		path: '/service/:id/forms',
		name: 'ServiceForms',
		component: () => import("@/pages/project/services/ServiceForms")
	},
	{
		path: '/service/:id/files',
		name: 'ServiceFiles',
		component: () => import("@/pages/project/JobFiles"),
		props: {
			storeLocation: "service",
			parentResource: "Service",
			parentRecordSlugRouteParamKey: "id"
		}
	},
	{
		path: '/service/:id/invoice/:tab',
		name: 'ServiceInvoiceWithTab',
		component: ServiceInvoice
	},
	{
		path: '/service/:id/invoice',
		name: 'ServiceInvoice',
		component: ServiceInvoice
	},
	{
		path: '/service/:id/report',
		name: 'ServiceReport',
		component: () => import("@/pages/project/services/ServiceReport")
	},
	{
		path: '/service/:id/time-logs',
		name: 'ServiceTimeLogs',
		component: () => import("@/pages/project/services/ServiceTimeLogs")
	},
	{
		path: '/service/:id/expenses',
		name: 'ServiceExpenses',
		component: () => import("@/pages/project/services/ServiceExpenses")
	},
	{
		path: '/service/:id/locates',
		name: 'ServiceLocates',
		component: () => import("@/pages/project/services/ServiceLocates")
	},
	{
		path: '/service/:id/purchase-orders',
		name: 'ServicePurchaseOrders',
		component: ServicePurchaseOrders
	},
	{
		path: '/service/:id/purchase-orders/:po_slug',
		name: 'ServicePurchaseOrderSelected',
		props: route => ({poSlug : route.params.po_slug}),
		component: ServicePurchaseOrders
	},
	{
		path: '/service/:id/apps',
		name: 'ServiceApps',
		component: () => import("@/pages/project/services/ServiceApps")
	},
	{
		path: '/financial/invoices',
		name: 'Invoices',
		component: () => import("@/pages/financial/Invoices")
	},
	{
		path: '/financial/purchase-orders/:po_slug',
		name: 'PurchaseOrdersWithSlug',
		props: route => ({poSlug : route.params.po_slug}),
		component: () => import("@/pages/financial/PurchaseOrdersFinancial")
	},
	{
		path: '/financial/purchase-orders',
		name: 'PurchaseOrders',
		component: () => import("@/pages/financial/PurchaseOrdersFinancial")
	},
	{
		path: '/financial/project-holdbacks',
		name: 'ProjectHoldbacks',
		component: () => import("@/pages/financial/ProjectHoldbacks")
	},
	{
		path: '/financial',
		name: 'FinancialMain',
		component: () => import("@/pages/financial/FinancialMain")
	},
	{
		path: '/invoice/:slug/:tab',
		name: 'Invoice',
		component: () => import("@/pages/project/services/GroupInvoice")
	},
	{
		path: '/job-settings/:setting',
		name: 'JobSettings',
		component: () => import('@/pages/project/JobSettings')
	},
	{
		path: '/project/:slug/note/view/:note_slug/',
		name: 'NotePrintView',
		component: () => import("@/pages/print_views/NotePrintView"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/project/:slug/notes/view',
		name: 'ProjectNotesPrintView',
		component: () => import("@/pages/print_views/ProjectNotesPrintView"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/project/:id/:tab/:tag',
		name: 'ProjectWithSubmenus',
		component: Project
	},
	{
		path: '/project/:id/:tab',
		name: 'Project',
		component: Project
	},
	{
		path: '/project-bid-summary/:bidSlug',
		name: 'ProjectBidSummaryFullscreen',
		component: () => import("@/pages/ProjectBidSummaryFullscreen")
	},
//////////////////////////
// CONTACTS
/////////////////////////
	{
		path: '/contacts',
		name: 'Customers',
		component: () => import('@/pages/Contacts')
	},
	{
		path: '/contacts/apps',
		name: 'ContactsApps',
		component: () => import('@/pages/contact/ContactsApps')
	},
	{
		path: '/contact/:id/details/:parent_slug',
		name: 'ContactDetailsWithSlug',
		component:  () => import('@/pages/contact/ContactDetails')
	},
	{
		path: '/contact/:id/summary',
		name: 'ContactSummary',
		component:  () => import('@/pages/contact/ContactSummary')
	},
	{
		path: '/contact/:id/details',
		name: 'ContactDetails',
		component:  () => import('@/pages/contact/ContactDetails')
	},
	{
		path: '/contact/:id/locations',
		name: 'ContactLocations',
		component: () => import('@/pages/contact/ContactLocations')
	},
	{
		path: '/contact/:id/jobs',
		name: 'ContactJobs',
		component: () => import('@/pages/contact/ContactJobs')
	},
	{

		path: '/contact/:id/files',
		name: 'ContactFiles',
		component: () => import("@/pages/project/JobFiles"),
		props: { 
			storeLocation: "contact",
			parentResource: "Contact",
			parentRecordSlugRouteParamKey: "id"
		}
	},
	{
		path: '/contact/:id/service-contracts',
		name: 'ContactServiceContracts',
		component: () => import("@/pages/project/ServiceContracts")
	},
	{
		path: '/contact/:id/sub-contacts',
		name: 'ContactSubContacts',
		component: () => import('@/pages/contact/ContactSubContacts')
	},
	{
		path: '/contact/:id/assets/:catSlug',
		name: 'CustomerAssetsWithCatSlug',
		component: () => import('@/pages/contact/CustomerAssets')
	},
	{
		path: '/contact/:id/assets',
		name: 'CustomerAssets',
		component: () => import('@/pages/contact/CustomerAssets')
	},
	{
		path: '/contact/:id/settings',
		name: 'ContactSettings',
		component: () => import('@/pages/contact/ContactSettings')
	},
	{
		path: '/contact/:id/purchases/:tab',
		name: 'SupplierContactPurchases',
		component: () => import('@/pages/contact/SupplierContactPurchases')
	},
	{
		path: '/contact/asset/:slug/:customer_id/:customer_location_id/:category_id',
		name: 'CustomerAssetPrefilledFields',
		component: () => import('@/pages/contact/CustomerAsset')
	},
	{
		path: '/contact/asset/:slug/:tab',
		name: 'CustomerAsset',
		component: () => import('@/pages/contact/CustomerAsset')
	},
	{
		path: '/contact-assets',
		name: 'CustomerAssetsMain',
		component: () => import('@/pages/CustomerAssetsMain')
	},
	{
		path: '/profile/:type/:slug',
		name: 'PublicProfile',
		component: () => import('@/pages/contact/PublicProfile'),
		meta: {
			noAuth: true
		}
	},
// END CONTACTS
	{
		path: '/punch-clock',
		name: 'PunchClock',
		component: PunchClock
	},
	{
		path: '/punch-clock/:jobType/:jobSlug',
		name: 'PunchClockWithTypeAndJob',
		component: PunchClock
	},
	{
		path: '/expenses/log',
		name: 'LogExpense',
		component: () => import("@/pages/LogExpense")
	},
	{
		path: '/expenses/review',
		name: 'ExpenseReview',
		component: () => import("@/pages/expenses/ExpenseReview")
	},
	{
		path: '/expenses/submitted',
		name: 'SubmittedExpenses',
		component: () => import("@/pages/expenses/SubmittedExpenses")
	},
	{
		path: '/expenses/submit-new',
		name: 'ExpenseSubmitNew',
		component: () => import("@/pages/expenses/ExpenseSubmitNew")
	},
	/*{
		path: '/expenses/history/:year',
		name: 'ExpenseHistoryYear',
		component: ExpenseHistory
	},
	{
		path: '/expenses/history',
		name: 'ExpenseHistory',
		component: ExpenseHistory
	},*/
	/*{
		path: '/expenses/submitted/:start_date/:end_date/:type',
		name: 'ExpensesPayPeriod',
		component: ExpensesPayPeriod
	},*/
	{
		path: '/expenses/list/:slug',
		name: 'ExpensesWithSlug',
		component: Expenses
	},
	{
		path: '/expenses/list',
		name: 'Expenses',
		component: Expenses
	},
	{
		path: '/time-logs/settings',
		name: 'TimeLogSettings',
		component: () => import("@/pages/time_logs/TimeLogSettings")
	},
	{
		path: '/time-logs/review',
		name: 'TimeLogsReview',
		component: () => import("@/pages/time_logs/TimeLogsReview")
	},
	{
		path: '/time-logs/submitted/:period_slug/detailed',
		name: 'TimeLogsPeriodDetailed',
		component: TimeLogsPeriod
	},
	{
		path: '/time-logs/submitted/:period_slug/summary',
		name: 'TimeLogsPeriodSummary',
		component: TimeLogsPeriod
	},
	{
		path: '/time-logs/history',
		name: 'TimeLogHistory',
		component: () => import("@/pages/time_logs/TimeLogHistory")
	},
	{
		path: '/time-logs/list/:slug',
		name: 'TimeLogsWithSlug',
		component: TimeLogs
	},
	{
		path: '/time-logs/list',
		name: 'TimeLogs',
		component: TimeLogs
	},
	{
		path: '/thank-you',
		name: 'ThankYouPage',
		component: () => import("@/pages/public_pages/ThankYouPage"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/collective-agreements',
		name: 'CollectiveAgreements',
		component: () => import("@/pages/CollectiveAgreements")
	},
	{
		path: '/messages',
		name: 'Messages',
		component:  () => import("@/pages/Messages")
	},
	{
		path: '/message/:threadSlug',
		name: 'ThreadOpen',
		component: () => import("@/pages/messages/ThreadOpen")
	},
	{
		path: '/company/details',
		name: 'SettingsCompanyDetails',
		component: () => import("@/pages/settings/SettingsCompanyDetails")
	},
	{
		path: '/company/collective-agreements',
		name: 'SettingsCollectiveAgreements',
		component: () => import("@/pages/settings/SettingsCollectiveAgreements")
	},
	/*{
		path: '/company/unions/:slug',
		name: 'SettingsUnionsUnion',
		component: SettingsUnions
	},
	{
		path: '/company/unions',
		name: 'SettingsUnions',
		component: SettingsUnions
	},*/
	{
		path: '/company/settings',
		name: 'SettingsCompanySettings',
		component: () => import("@/pages/settings/SettingsCompanySettings")
	},
	{
		path: '/permission-templates',
		name: 'PermissionTemplates',
		component: () => import("@/pages/settings/PermissionTemplates")
	},
	{
		path: '/materials/list',
		name: 'MaterialsList',
		component: () => import("@/pages/materials/MaterialsList")
	},
	{
		path: '/materials/assemblies',
		name: 'MaterialAssemblies',
		component: () => import("@/pages/materials/MaterialAssemblies")
	},
	{
		path: '/materials/apps',
		name: 'MaterialsApps',
		component: () => import("@/pages/materials/MaterialsApps")
	},
	{
		path: '/materials/settings',
		name: 'MaterialsSettings',
		component: () => import("@/pages/materials/MaterialsSettings")
	},
	{
		path: '/labour-tasks/list',
		name: 'LabourActionsList',
		component: () => import("@/pages/labour_actions/LabourActionsList")
	},
	{
		path: '/equipment/settings',
		name: 'EquipmentTypes',
		component: () => import("@/pages/equipment/EquipmentTypes")
	},
	{
		path: '/equipment/maintenance-schedule',
		name: 'EquipmentMaintenanceSchedule',
		component: () => import("@/pages/equipment/EquipmentMaintenanceSchedule")
	},
	{
		path: '/equipment/item/:slug/:tab/:tabRecordSlug',
		name: 'EquipmentItemWithRecordSlug',
		component: () => import("@/pages/equipment/equipment_item/EquipmentItem")
	},
	{
		path: '/equipment/item/:slug/:tab',
		name: 'EquipmentItem',
		component: () => import("@/pages/equipment/equipment_item/EquipmentItem")
	},
	{
		path: '/equipment/item/:slug',
		name: 'EquipmentItemWithSlug',
		component: () => import("@/pages/equipment/equipment_item/EquipmentItem")
	},
	{
		path: '/equipment/view/:slug',
		name: 'EquipmentPrintView',
		component: () => import("@/pages/print_views/MaintenanceLogPrint"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/equipment/:cat_slug/:type_slug',
		name: 'EquipmentList',
		component: () => import("@/pages/equipment/EquipmentList")
	},
	{
		path: '/equipment/forms',
		name: 'EquipmentForms',
		component: () => import("@/pages/equipment/EquipmentForms")
	},
	{
		path: '/equipment/apps',
		name: 'EquipmentApps',
		component: () => import("@/pages/equipment/EquipmentApps")
	},
	{
		path: '/equipment/geo-tracking',
		name: 'EquipmentGeoTracking',
		component: () => import("@/pages/equipment/EquipmentGeoTracking")
	},
	{
		path: '/equipment/settings',
		name: 'EquipmentSettings',
		component: () => import("@/pages/equipment/EquipmentTypes")
	},
	{
		path: '/equipment/:cat_slug',
		name: 'EquipmentListWithCat',
		component: () => import("@/pages/equipment/EquipmentList")
	},
	{
		path: '/equipment',
		name: 'Equipment',
		component: () => import("@/pages/equipment/EquipmentList")
	},
	{
		path: '/library/file/:slug/:view_type',
		name: 'LibraryListWithSlug',
		component: LibraryList
	},
	{
		path: '/library/files/:tag',
		name: 'LibraryList',
		component: LibraryList
	},
	{
		path: '/library/files',
		name: 'LibraryListAll',
		component: LibraryList
	},
	{
		path: '/employers',
		name: 'Employers',
		component: () => import('@/pages/Employers')
	},
	{
		path: "/schedule/:view/:date",
		name: "ScheduleWithViewWithDate",
		component: () => import("@/pages/Schedule")
	},
	{
		path: "/schedule/:date",
		name: "ScheduleWithDate",
		component: () => import("@/pages/Schedule")
	},
	{
		path: "/schedule",
		name: "Schedule",
		component: () => import("@/pages/Schedule")
	},
	{
		path: "/schedule-timeline/:jobType/:slug",
		name: "ScheduleTimelinePrintView",
		component: () => import("@/pages/print_views/ScheduleTimelinePrintView")
	},
	{
		path: '/certificates/matrix',
		redirect: to => {return {path: '/safety/certificates/matrix'}}
	},
	{
		path: '/safety/certificates/matrix',
		name: 'TrainingCertificates',
		component: () => import("@/pages/safety/TrainingCertificates")
	},
	{
		path: '/safety/certificates/list',
		name: 'ManageCertificates',
		component: () => import("@/pages/safety/ManageCertificates")
	},
	{
		path: '/safety/apps',
		name: 'SafetyApps',
		component: () => import("@/pages/safety/SafetyApps")
	},
	{
		path: '/form/view/:slug',
		name: 'FormPrintView',
		component: () => import("@/pages/print_views/FormPrint"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/forms/template-editor/:cat_slug/:slug',
		name: 'FormTemplateEditorWithCategory',
		component: () => import("@/pages/forms/FormTemplateEditor")
	},
	{
		path: '/forms/template-editor/:slug',
		name: 'FormTemplateEditor',
		component: () => import("@/pages/forms/FormTemplateEditor")
	},
	{
		path: '/forms/child-template-editor/:template_slug/:slug',
		name: 'FormChildTemplateEditorWithTemplate',
		component: () => import("@/pages/forms/FormChildTemplateEditor")
	},
	{
		path: '/forms/child-template-editor/:slug',
		name: 'FormChildTemplateEditor',
		component: () => import("@/pages/forms/FormChildTemplateEditor")
	},
	{
		path: '/forms/templates/:cat_slug/:template_slug',
		name: 'FormsWithCategoryAndTemplate',
		component: FormTemplates
	},
	{
		path: '/forms/templates/:cat_slug',
		name: 'FormsWithCategory',
		component: FormTemplates
	},
	{
		path: '/forms/templates',
		name: 'FormTemplates',
		component: FormTemplates
	},
	{
		path: '/forms/list',
		name: 'FormList',
		component: () => import("@/pages/forms/FormList")
	},
	{
		path: '/forms/marketplace',
		name: 'FormsMarketplace',
		component: () => import("@/pages/forms/FormMarketplace")
	},
	{
		path: '/forms/:tab',
		name: 'FormsTab',
		component: () => import("@/pages/forms/Forms")
	},
	{
		path: '/forms',
		name: 'Forms',
		component: FormTemplates
	},
	{
		path: '/do-form/:child_template_slug',
		name: 'DoCompanyForm',
		component: () => import("@/pages/forms/DoCompanyForm")
	},
	{
		path: '/form/external/:slug/:acknowledgement_slug/:token',
		name: 'ExternalFillableFormWithToken',
		component: () => import("@/pages/forms/ExternalFillableForm"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/form/external/:slug/:acknowledgement_slug',
		name: 'ExternalFillableForm',
		component: () => import("@/pages/forms/ExternalFillableForm")
	},
	/*
	{
		path: '/feed',
		name: 'Feed',
		component: () => import("@/pages/Feed")
	},
	*/
	{
		path: '/notifications/feed',
		name: 'NotificationCenter',
		component: () => import("@/pages/notifications/NotificationCenter")
	},
	{
		path: '/notifications/news',
		name: 'ReleaseNotes',
		component: () => import("@/pages/notifications/ReleaseNotes")
	},
	{
		path: '/notifications/settings',
		name: 'NotificationSettings',
		component: () => import("@/pages/notifications/NotificationSettings")
	},
	{
		path: '/subscription',
		name: 'Subscription',
		component: () => import("@/pages/Subscription")
	},
	/*
	{
		path: '/setup/unions',
		name: 'SetupUnionList',
		component: () => import("@/pages/setup/SetupUnionList")
	},
	*/
	{
		path: '/locates/:ticket_num',
		name: 'LocatesWithTicketNum',
		component: () => import("@/pages/Locates")
	},
	{
		path: '/locates',
		name: 'Locates',
		component: () => import("@/pages/Locates")
	},
	/*{
		path: '/app/:slug',
		name: 'SettingsIntegrations',
		component: SettingsIntegrations
	},*/
	{
		path: '/apps/integrations',
		name: 'Integrations',
		component: () => import("@/pages/apps/Integrations")
	},
	{
		path: '/apps/main',
		name: 'AppsMain',
		component: () => import ("@/pages/apps/AppsMain")
	},
	{
		path: '/apps/installed',
		name: 'InstalledApps',
		component: () => import("@/pages/apps/InstalledApps")
	},
	{
		path: '/apps/store',
		name: 'AppStore',
		component: () => import("@/pages/apps/AppStore")
	},
	{
		path: '/apps/published',
		name: 'PublishedApps',
		component: () => import("@/pages/apps/PublishedApps")
	},
	{
		path: '/setup/free/success',
		name: 'FreeTierSuccess',
		component: () => import("@/pages/setup_wizard/FreeTierSuccess")
	},
	{
		path: '/setup/:sectionNum/:token',
		name: 'SetupShared',
		component: () => import("@/pages/setup_wizard/SetupWizard"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/setup/:sectionNum',
		name: 'SetupSection',
		component: () => import("@/pages/setup_wizard/SetupWizard")
	},
	{
		path: '/setup',
		name: 'Setup',
		component: () => import("@/pages/setup_wizard/SetupWizard")
	},
	{
		path: '/onboarding/:sectionNum/:token',
		name: 'OnboardingWizardSectionShared',
		component: () => import("@/pages/setup_wizard/OnboardingWizard"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/onboarding/:sectionNum',
		name: 'OnboardingWizardWithSection',
		component: () => import("@/pages/setup_wizard/OnboardingWizard")
	},
	{
		path: '/onboarding',
		name: 'OnboardingWizard',
		component: () => import("@/pages/setup_wizard/OnboardingWizard")
	},
	{
		path: '/redirect/:type/:id',
		name: 'Redirect',
		component: () => import("@/pages/Redirect"),
		meta: {
			noAuth: true
		}
	},
	{
		path: '/do-form/:id',
		name: 'DoCompanyForm',
		component: () => import("@/pages/forms/DoCompanyForm")
	}
]